import type { SendRawTransactionResponse } from '@/src/services/walletService';
import walletStore from '@/src/stores/walletStore';
import walletMessageChannel from '../walletMessageChannel';

export type SendRawTransactionTx = {
  chainId: number;
  transactionData: string;
  to: string;
};

export type SendRawTransactionHandler = (
  tx: SendRawTransactionTx
) => Promise<SendRawTransactionResponse>;

export const onSendRawTransaction: SendRawTransactionHandler = (tx) => {
  return new Promise<SendRawTransactionResponse>((resolve, reject) => {
    walletStore.setState({
      request: {
        type: 'sendRawTransaction',
        ...tx,
      },
    });
    walletMessageChannel.sendRawTransactionResolve = resolve;
    walletMessageChannel.requestReject = reject;
  });
};
